import axios from 'redaxios'

axios.defaults.baseURL = process.env.VUE_APP_API_BACKEND
// axios.defaults.headers.common['Authorization'] = 'AUTH TOKEN';
// axios.defaults.headers.post['Content-Type'] = 'application/json';

export default axios
